module.exports = __webpack_public_path__ + "static/MonoramaBold-4cc84bf607e1075c060454a33f6a8115.woff";